import TripIdea from './TripIdea';

export default TripIdea;
